export const WIDE_BREAKPOINT = 768;
export const COMPACT_PREVIEW_BREAKPOINT = 520;
export const PREVIEW_PAGE_SIZES = [10, 25, 50] as const;
export type PreviewPageSize = (typeof PREVIEW_PAGE_SIZES)[number];

export type PreviewRowView = {
  rowNumber: number;
  status: string;
  action: string;
  detail: string;
  message?: string;
};

export type PreviewCounts = {
  altas: number;
  modificaciones: number;
  errores: number;
  avisos: number;
  iguales: number;
};

/** Aviso no bloqueante: mensaje con prefijo "Aviso:" (ej. barcode inválido en update). */
export function previewRowHasAviso(row: Pick<PreviewRowView, 'status' | 'message'>): boolean {
  if (row.status === 'error') return false;
  const msg = row.message?.trim() ?? '';
  return /^aviso\b/i.test(msg);
}

/** Errores y avisos primero; después cambios; iguales al final. */
const PREVIEW_STATUS_ORDER: Record<string, number> = {
  error: 0,
  ok: 1,
  skip: 2,
};

export function sortPreviewRowsForReview(rows: PreviewRowView[]): PreviewRowView[] {
  return [...rows].sort((a, b) => {
    const pa = PREVIEW_STATUS_ORDER[a.status] ?? 9;
    const pb = PREVIEW_STATUS_ORDER[b.status] ?? 9;
    if (pa !== pb) return pa - pb;
    const avisoA = previewRowHasAviso(a) ? 0 : 1;
    const avisoB = previewRowHasAviso(b) ? 0 : 1;
    if (pa === 1 && avisoA !== avisoB) return avisoA - avisoB;
    return a.rowNumber - b.rowNumber;
  });
}

export function previewAccionTone(
  status: string,
  action: string,
  hasAviso = false
): 'alta' | 'edicion' | 'error' | 'igual' | 'aviso' {
  if (status === 'error') return 'error';
  if (status === 'skip' || action === 'omitir') return 'igual';
  if (hasAviso) return 'aviso';
  if (action === 'crear') return 'alta';
  return 'edicion';
}

export function plural(n: number, one: string, many: string): string {
  return n === 1 ? one : many;
}
